<micro-lookup domain="reactor" obj="reactors" url="/reactors" [key]="reactorId" [link]="link"></micro-lookup>
